import { nav } from "../../../packages/static/navigation/src/index";
import { accordion } from "../../../packages/static/Accordion";
import {
  // collapseRegion,
  isSpecialEvent
} from "../../helpers";
import { HeroCircuitInit } from "../../static/HeroCircuit";
import HomePageInit from "../../static/HomePageLayout/init";
import { mediaSizes, debounce } from "../../helpers";
import scrollTop from "../../static/Page/src/scrollTop";
import {
  CircuitLandingInit,
  handleExpand
} from "../../static/CircuitLandingPage/circuitNav";
import { StatisticsInit } from "../../static/Statistics";
import { load365Form } from "../../static/Lightbox/src/coachingForm";
import { isOlympics } from "../../helpers";
import { tournamentBannerGradeScript } from "../../static/TournamentHero";
import { SignUpFormScript } from "../../static/SignUp/form";
import { addCTAForRibbonWidget } from "../../services/widgetSDK";
import { themeEmitter } from "../../static/Theming";
import { ResponsiveTableScript } from "../../static/ResponsiveTable";

// Call all static modules once the dom has loaded
document.addEventListener("DOMContentLoaded", function() {
  const aboutSectionInit = () => {
    // const p: HTMLElement | null = document.querySelector(
    //   ".about-section-container section p"
    // );
    // const h2: HTMLElement | null = document.querySelector(
    //   ".about-section-container section h2"
    // );

    const children: HTMLElement[] | null = Array.from(
      document.querySelectorAll(".about-section-container section p")
    );
    const button: HTMLElement | null = document.querySelector(
      ".about-tournament-container .btn--read-more"
    );

    if (children.length < 2 && button !== null) {
      button.style.display = "none";
    }

    // if (p !== null && h2 !== null) {
    //   collapseRegion({
    //     collapseHeight: p.offsetHeight + h2.offsetHeight + 32,
    //     elClassName: "about-section"
    //   });
    // }
  };

  document
    .querySelectorAll(".itf-tour__link.expandable")
    .forEach((el: EventTarget) => {
      // @ts-ignore
      el.addEventListener("click", handleExpand);
    });

  document.querySelectorAll("style").forEach(styleTag => {
    const sheet = styleTag.sheet;

    try {
      if (!sheet) return;
      // @ts-ignore
      const rules = sheet.cssRules;
      if (!rules) return;

      for (let i = rules.length - 1; i >= 0; i--) {
        const rule = rules[i];

        // Check if it's a CSSStyleRule
        // @ts-ignore
        if (rule instanceof CSSStyleRule) {
          if (rule.selectorText === "p" && rule.style.margin === "0px") {
            // @ts-ignore
            sheet.deleteRule(i);
          }
        }
      }
    } catch (e) {
      console.warn("Skipping inaccessible stylesheet:", e);
    }
  });

  aboutSectionInit();

  scrollTop();
  nav();
  HeroCircuitInit();
  HomePageInit();
  CircuitLandingInit();
  StatisticsInit();

  const mainEl = document.querySelector("main");

  if (isSpecialEvent && mainEl !== null) {
    mainEl.classList.add("special-event");
  }

  // temporary variables
  const pathnames = location.pathname.split("/").filter(val => val) || [];
  const isToursLanding = pathnames.length > 1 && pathnames[1].includes("tours");

  // adding of class to DOM elements on tours kanding pages
  if (isToursLanding) {
    // @ts-ignore
    document.querySelector("body").classList.add("itf-tour__landing");
  }

  const faqAccordion = () => {
    accordion(
      ".accordion__column",
      ".accordion__contents",
      ".accordion__subheading",
      true
    ).create();
  };

  faqAccordion();

  // Main menu layout update on debounce

  const mainMenuAccordion = () => {
    const { create, undo } = accordion(
      ".main-nav__links li",
      ".sub-nav",
      ".main-nav__link",
      true,
      false
    );
    if (window.innerWidth < mediaSizes.tabletLarge) {
      create();
    } else {
      undo();
    }
  };

  mainMenuAccordion();

  const footerAccordion = () => {
    const { create, undo } = accordion(
      ".footer-column",
      "ul",
      ".subheading",
      true,
      false
    );

    const condition = window.innerWidth < mediaSizes.tabletLarge;

    if (condition) {
      create();
    } else {
      undo();
    }
  };

  if (window.innerWidth < mediaSizes.tablet) {
    footerAccordion();
  }

  //Detect Events page landing page
  const path = window.location.href;

  if (path.split("/").includes("events")) {
    const breadcrumbs = document.getElementsByClassName("breadcrumb");
    for (const item of Array.from(breadcrumbs) as HTMLElement[]) {
      item.style.display = "none";
    }
  }

  const sections: HTMLElement[] | any[] = Array.from(
    document.querySelectorAll(
      ".homepage .page-section, .homepage .video-background"
    )
  ).filter(item => !item.classList.contains("page-section--mobile"));

  sections.forEach((item: any, key: number) => {
    const sibling = key < sections.length - 1 ? sections[key + 1] : null;
    if (sibling) {
      if (
        (sibling.classList.contains("video-background") ||
          sibling.getAttribute("style") !== null) &&
        (item.classList.contains("video-background") ||
          item.getAttribute("style") !== null)
      ) {
        item.classList.add("add-margin");
      }
    }
  });

  // OlympicsCTA group
  const olDoubleCtaDivs = document.querySelectorAll('div[id^="ol-double-cta"]');

  // Iterate over each selected div
  olDoubleCtaDivs.forEach(function(div) {
    let prevSibling = div.previousElementSibling;
    while (prevSibling && prevSibling.tagName === "SCRIPT") {
      prevSibling = prevSibling.previousElementSibling;
    }

    let nextSibling = div.nextElementSibling;
    while (nextSibling && nextSibling.tagName === "SCRIPT") {
      nextSibling = nextSibling.nextElementSibling;
    }

    if (
      (prevSibling && prevSibling.id.startsWith("ol-double")) ||
      (nextSibling && nextSibling.id.startsWith("ol-double"))
    ) {
      div.classList.add("cta-group");
    }
  });

  // hide mobile account icon when disable from CMS

  const accountDisabled = !document.querySelectorAll(
    ".my-account__account--btn"
  ).length;
  const accountMobileButtons = document.querySelectorAll(
    ".main-nav__link--account.mobile"
  );

  if (accountDisabled && accountMobileButtons != null) {
    accountMobileButtons.forEach(btn => {
      // @ts-ignore
      btn.style.display = "none";
    });
  }

  const ctaGroups = document.querySelectorAll(".cta-group");

  ctaGroups.forEach((div, index) => {
    if (index === 0) {
      div.classList.add("first-module");
    } else if (index === ctaGroups.length - 1) {
      div.classList.add("last-module");
    }
  });

  if (location.pathname === "/en/") {
    // @ts-ignore
    document.querySelector("body").classList.add("home");
  }

  if (isOlympics) {
    const el = document.querySelector(".landing-page");

    if (el) {
      el.classList.add("olympics");
      themeEmitter({ layoutVersion: 1, name: "olympics" });
    }
  }

  const landingPage = document.querySelector(".landing-page");
  const isParalympics = location.href.indexOf("paralympics") >= 0;
  const isOlympicsPage =
    landingPage && landingPage.classList.contains("olympics");

  if (landingPage && isOlympicsPage && isParalympics) {
    landingPage.classList.add("para");
    themeEmitter({ layoutVersion: 1, name: "olympics" });
  }

  ResponsiveTableScript();
  tournamentBannerGradeScript();
  SignUpFormScript();

  debounce({
    func: () => {
      aboutSectionInit();
      footerAccordion();
      mainMenuAccordion();
    }
  });

  const doubleCTAModules = Array.from(
    document.querySelectorAll("div[id*=player-pathway-double-cta]")
  );

  if (doubleCTAModules.length > 1) {
    doubleCTAModules
      .splice(1)
      .forEach(module => module.classList.add("padding-reduce"));
  }

  load365Form();
  setTimeout(() => {
    addCTAForRibbonWidget("Live Match Centre");
  }, 2000); // delay for Ribbon widget

  const themeObject = document.querySelector("#custom-theme");
  const layoutVersion =
    themeObject !== null
      ? parseInt(`${themeObject.getAttribute("layout-version")}`)
      : 1;

  themeEmitter({ layoutVersion });
});
